import _ from 'lodash';
import { Text } from 'common-components/typography';
import React from 'react';

import { EndSpacer } from '../roster-daily/components/EndSpacer';
import { ROSTER_DAILY_CONFIG } from '../roster-daily/roster-daily-config';

const { HOUR_BLOCK_WIDTH, HOUR_BLOCK_HEIGHT } = ROSTER_DAILY_CONFIG;

interface HourBlockProps {
  hour: string;
  first?: boolean;
}

function HourBlock({ hour, first }: HourBlockProps) {
  return (
    <div
      className={`line-height-100 bordered-bottom bordered-top text-align-center select-none flex-row align-center justify-center bg-quaternary ${first ? '' : 'bordered-left'}`}
      style={{ minWidth: `${HOUR_BLOCK_WIDTH}px`, maxWidth: `${HOUR_BLOCK_WIDTH}px`, height: HOUR_BLOCK_HEIGHT }}
    >
      <Text lineHeight={100} size='regular' color='secondary'>
        {hour}
      </Text>
    </div>
  );
}

interface HoursDisplayProps {
  hours: string[];
}

export function HoursDisplay({ hours }: HoursDisplayProps) {
  return (
    <div>
      <div className='flex-row bg-quaternary'>
        {_.map(hours, (hour, idx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <HourBlock key={idx} hour={hour} first={idx === 0} />
        ))}
        <EndSpacer height={HOUR_BLOCK_HEIGHT} />
      </div>
    </div>
  );
}
